export { default } from './ColumnChartWidget';
